(() => {
  window.swinger.eventHub.register('change', '.swinger-language-switcher .swinger-select__select', (e) => {
    const targetUrl = window.swinger.eventHub.getTarget(e).value || '/';
    const searchQuery = window.location.search;

    window.location.href = targetUrl.indexOf('?') === -1 ? `${targetUrl}${searchQuery}` : targetUrl;
  });
})();
